var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"accordion-room-bedrooms"},[_c('form-range-input',{attrs:{"theme":"creator","min":1,"max":10,"dot-size":48},model:{value:(_vm.fields.bedroomsValue),callback:function ($$v) {_vm.$set(_vm.fields, "bedroomsValue", $$v)},expression:"fields.bedroomsValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }